import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { FreeTrialPage } from './pages/FreeTrialPage';
import { PricingPage } from './pages/PricingPage';
import { LoginPage } from './pages/LoginPage';
import { ContactPage } from './pages/ContactPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { VSLPage } from './pages/VSLPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-22">
      <Routes data-id="element-23">
        <Route path="/" element={<App data-id="element-25" />} data-id="element-24" />
        <Route path="/trial" element={<FreeTrialPage data-id="element-27" />} data-id="element-26" />
        <Route path="/pricing" element={<PricingPage data-id="element-29" />} data-id="element-28" />
        <Route path="/login" element={<LoginPage data-id="element-31" />} data-id="element-30" />
        <Route path="/contact" element={<ContactPage data-id="element-33" />} data-id="element-32" />
        <Route path="/terms-and-conditions" element={<TermsPage data-id="element-35" />} data-id="element-34" />
        <Route path="/privacy-policy" element={<PrivacyPage data-id="element-37" />} data-id="element-36" />
        <Route path="/vsl" element={<VSLPage data-id="element-39" />} data-id="element-38" />
      </Routes>
    </BrowserRouter>;
}